import React from 'react';

// Empty-state mark for Portfolio: a gradient "$" inside a circle within the shared
// gradient-bordered tile. Rendered at its native 80px (drawn in an 80x80 viewBox);
// the frame is part of the artwork. Gradient ids are per-instance (useId) so
// multiple copies on a page don't collide.
const NoPortfolioIcon = ({ size = 80 }) => {
  const uid = React.useId();
  const g = (n) => `no_portfolio_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="79" height="79" rx="11.5" stroke={`url(#${g(0)})`} />
      <path d="M40 27V53" stroke={`url(#${g(1)})`} strokeLinecap="round" />
      <path
        d="M46 32.2624C44.5882 29.9929 42.4706 29 40.0706 29C36.8235 29 34.1412 30.7021 34.1412 33.539C34.1412 39.7801 46 36.8014 46 43.7518C46 46.7305 43.3176 49 40.0706 49C37.3882 49 35.1294 47.7234 34 45.4539"
        stroke={`url(#${g(2)})`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5 58C49.7173 58 58 49.9411 58 40C58 30.0589 49.7173 22 39.5 22C29.2827 22 21 30.0589 21 40C21 49.9411 29.2827 58 39.5 58Z"
        stroke={`url(#${g(3)})`}
      />
      <defs>
        <linearGradient id={g(0)} x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7853F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(1)} x1="40.5" y1="27" x2="40.5" y2="53" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(2)} x1="40" y1="29" x2="40" y2="49" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(3)} x1="39.5" y1="22" x2="39.5" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoPortfolioIcon;
